<template>
  <div class="communityManagementsList">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-input class="searchInput" v-model="gardenName" placeholder="请输入项目名称搜索"></el-input>
        </el-form-item>
        <el-button type="primary" @click="gardens()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="jumpToAdd">{{detail.add}}</el-button>
      <el-table  :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
       <el-table-column type="selection" width="55" v-if="this.communityManagementsListkbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="name" :label="detail.houseNames">
        </el-table-column>
        <el-table-column prop="provinces" :label="detail.provinces" width="290">
        </el-table-column>
        <el-table-column prop="cityName" :label="detail.citys" width="290">
        </el-table-column>
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)">{{$t('lang.btn_modify')}}</el-button>
            <el-button class=" orange" @click="deleteItem(scope.row)">{{$t('lang.btn_delete')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>
<script>
  /**
   *@ClassName:communityManagementsList
   *@Description:小区管理
   *@author:邹恒志
   *@Copyright:格众科技
   *@date:2020-02-27
   */
  export default {
    data() {
      return {
        communityManagementsListkbox: require('@/config/enum').communityManagementsListkbox,
        cities: require('@/config/cityAll').cities.provinces, // 查询
        editListArr: [], // 保存修改列表所有数据
        pageCount: 0, // 总数
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        tableData: [], // 所有小区存储
        formInline: {
          housing: '', // 帅选是的id
        },
        provinces: '',
        eagleEyeList: [], // 详情列表
        detail: this.$i18n.t('lang.housearea'),
        // eagledetail: require('@/config/enum').eagleEye,
        gardenName: '', // 模糊搜素
      }
    },
    created() {
      setTimeout(() => {
        window.localStorage.setItem('xqform', '')
        window.localStorage.setItem('xqsaveData', '')
      }, 200)
      this.gardens()
    },
    methods: {
      // 序号
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 修改按钮事件
      edit(row) {
        console.log(row)
        this.cities.forEach(function (item, index) {
          if (item.name == row.provinces) {
            row.provinces = item.id
          }
        })
				var adFlag
				var onlyOpenDoor
				var isDisplay
				var isLiftControl
        var isShareDoor
        var isShareLift
				var gardenLogo
        var qrcodeImgUrl
				var gardenLogoType
        var longitude
        var latitude
        var gardenInfo
        var floorArea
        var coverArea
        var outletsCount
        var buildingsCount
        var unitsCount
        var houseHolds
        var liftCount
        var parkCount
        var feePrice
        var feeParkPrice
        var gardenValid
        var gardenDeleteValid
        var complainUrl
        var gardenArea
        var affiliatedCompany
        var projectCode
        var sortId
        var themeColor
				if (row.adFlag == null) { adFlag = '' } else { adFlag = row.adFlag.toString() }
				if (row.onlyOpenDoor == null) { onlyOpenDoor = '' } else { onlyOpenDoor = row.onlyOpenDoor.toString() }
				if (row.isDisplay == null) { isDisplay = '' } else { isDisplay = row.isDisplay.toString() }
				if (row.isLiftControl == null) { isLiftControl = '' } else { isLiftControl = row.isLiftControl.toString() }
        if (row.isShareDoor == null) { isShareDoor = '' } else { isShareDoor = row.isShareDoor.toString() }
        if (row.isShareLift == null) { isShareLift = '' } else { isShareLift = row.isShareLift.toString() }
				if (row.gardenLogo == null) { gardenLogo = '' } else { gardenLogo = row.gardenLogo.toString() }
        if (row.qrcodeImgUrl == null) { qrcodeImgUrl = '' } else { qrcodeImgUrl = row.qrcodeImgUrl.toString() }
				if (row.gardenLogoType == null) { gardenLogoType = '' } else { gardenLogoType = row.gardenLogoType.toString() }
        if (row.longitude == null) { longitude = '' } else { longitude = row.longitude.toString() }
        if (row.latitude == null) { latitude = '' } else { latitude = row.latitude.toString() }
        if (row.gardenInfo == null) { gardenInfo = '' } else { gardenInfo = row.gardenInfo.toString() }
        if (row.floorArea == null) { floorArea = '' } else { floorArea = row.floorArea.toString() }
        if (row.coverArea == null) { coverArea = '' } else { coverArea = row.coverArea.toString() }
        if (row.outletsCount == null) { outletsCount = '' } else { outletsCount = row.outletsCount.toString() }
        if (row.buildingsCount == null) { buildingsCount = '' } else { buildingsCount = row.buildingsCount.toString() }
        if (row.unitsCount == null) { unitsCount = '' } else { unitsCount = row.unitsCount.toString() }
        if (row.houseHolds == null) { houseHolds = '' } else { houseHolds = row.houseHolds.toString() }
        if (row.liftCount == null) { liftCount = '' } else { liftCount = row.liftCount.toString() }
        if (row.parkCount == null) { parkCount = '' } else { parkCount = row.parkCount.toString() }
        if (row.feePrice == null) { feePrice = '' } else { feePrice = row.feePrice.toString() }
        if (row.feeParkPrice == null) { feeParkPrice = '' } else { feeParkPrice = row.feeParkPrice.toString() }
        if (row.gardenValid == null) { gardenValid = '' } else { gardenValid = row.gardenValid.toString() }
        if (row.gardenDeleteValid == null) { gardenDeleteValid = '' } else { gardenDeleteValid = row.gardenDeleteValid.toString() }
        if (row.complainUrl == null) { complainUrl = '' } else { complainUrl = row.complainUrl.toString() }
        if (row.gardenArea == null) { gardenArea = '' } else { gardenArea = row.gardenArea }
        if (row.affiliatedCompany == null) { affiliatedCompany = '' } else { affiliatedCompany = row.affiliatedCompany }
        if (row.projectCode == null) { projectCode = '' } else { projectCode = row.projectCode }
        if (row.sortId == null) { sortId = '' } else { sortId = row.sortId.toString() }
        if (row.themeColor == null) { themeColor = '#00a83c' } else { themeColor = row.themeColor.toString() }
        this.$router.push({
          name: 'communityManagementsadd',
          query: {
            provinces: row.provinces,
            cityId: row.cityId,
            id: row.id,
            adFlag: adFlag,
            onlyOpenDoor: onlyOpenDoor,
            isDisplay: isDisplay,
            isLiftControl: isLiftControl,
            isShareDoor: isShareDoor,
            isShareLift: isShareLift,
            gardenLogo: gardenLogo,
            qrcodeImgUrl: qrcodeImgUrl,
            gardenLogoType: gardenLogoType,
            name: row.name,
            parkCode: row.parkCode,
            gardenCode: row.gardenCode,
            urls: row.urls,
            urls3: row.urls3,
            urls4: row.urls4,
            urls5: row.urls5,
            urls6: row.urls6,
            urls7: row.urls7,
            urls8: row.urls8,
            urls9: row.urls9,
            flag: '0',
            longitude: row.longitude,
            latitude: row.latitude,
            gardenInfo: row.gardenInfo,
            floorArea: row.floorArea,
            coverArea: row.coverArea,
            outletsCount: row.outletsCount,
            buildingsCount: row.buildingsCount,
            unitsCount: row.unitsCount,
            houseHolds: row.houseHolds,
            liftCount: row.liftCount,
            parkCount: row.parkCount,
            feePrice: row.feePrice,
            feeParkPrice: row.feeParkPrice,
            gardenValid: row.gardenValid,
            gardenDeleteValid: row.gardenDeleteValid,
            gardenPhoto: row.gardenPhoto,
            complainUrl: row.complainUrl,
            staffNum: row.staffNum,
            onGroundArea: row.onGroundArea,
            unGroundArea: row.unGroundArea,
            feeArea: row.feeArea,
            venueCount: row.venueCount,
            deviceCount: row.deviceCount,
            peoExitCount: row.peoExitCount,
            nopeoExitCount: row.nopeoExitCount,
            carExitCount: row.carExitCount,
            mixExitCount: row.mixExitCount,
            gardenArea: row.gardenArea,
            affiliatedCompany: affiliatedCompany,
            projectCode: projectCode,
            sortId: sortId,
            themeColor: themeColor,

          }
        })
      },
      jumpToAdd() {
        this.$router.push({
          name: 'communityManagementsadd',
          query: {
            flag: 1
          }
        })
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 小区下拉
      gardens() {
        let loading = this.$loading()
        this.$get(`/gardensAndImage?gardenName=${this.gardenName}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`).then(
          res => {
            console.log(res.list)
            loading.close()
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
              console.log(this.cities)
              // 根据城市id查找其所属省份
              this.cities.forEach((item, index) => {
                if (item.items) {
                  item.items.forEach((itt, idx) => {
                    if (itt.items) {
                      itt.items.forEach((iit, ix) => {
                        this.tableData.forEach((im, i) => {
                          if (im.cityId == itt.id || im.cityId == iit.id) {
                            im.provinces = item.name
                            this.provinces = item.id
                          }
                        })
                      })
                    }
                  })
                }
              })
              console.log(this.tableData)
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 提交按钮
      commit() {
        let loading = this.$loading()
        console.log(this.formInline.housing)
        this.$get(
            `/videoMonitorInterfaceList?gardenId=${this.formInline.housing}&pageSize=${this.pageSize}&pageNo=${this.pageNo}`
          )
          .then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.eagleEyeList = res.list
                // this.total = res.pageCount
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.gardens()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.gardens()
      },
      //  删除按钮
      deleteItem(row) {
        console.log(row)
        let loading = this.$loading()
        this.$confirm(this.$i18n.t('lang.lab_isdelete'),
            this.$i18n.t('lang.lab_prompt'), {
              confirmButtonText: this.$i18n.t('lang.btn_confirm'),
              cancelButtonText: this.$i18n.t('lang.btn_cancel'),
              type: 'warning'
            })
          .then(() => {
            this.$delete(`/gardens/${row.id}`).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.gardens()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>